import { BASE_API_URL, API_AUTHCODE} from "../../lib/constants";
import { useRouter } from "next/router";

function useRedirectHandler(url){
   const router = useRouter();
  
   const redirectHandle = async(url)=>{
   
    
    let res = await fetch(
        BASE_API_URL + "wp/v2/redirections",
        {
          headers: {
            // Authorization: API_AUTHCODE,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      )
      let result = await res.json();

    if (result) {
        Object.keys(result).forEach(function (key) {
          let newKey = "";
          let urlArray = key.split("//");
          if (urlArray[1]) {
            let urlString = urlArray[1];
            let urlnewArray = urlString.split("/");
            urlnewArray.shift();
            newKey = window.location.origin + "/" +  urlnewArray.join("/")+"/";
          } else {
            let urlString = key;
            let urlnewArray = urlString.split("/");
            let arr = urlnewArray.filter((entry) => entry.trim() != "");
  
            newKey = window.location.origin + "/" + arr.join("/")+"/";
          }
         
          if(newKey==url)
          {
            
            let newUrl = getUrlSlug(result[key]);
            router.push(newUrl);
          }
          
        });
      }
      
   };
const getUrlSlug=(newurl)=> {
    if (newurl) {
      let slug = "";
      let urlArray = newurl.split("//");

      if (urlArray[1]) {
        let urlNewArray = urlArray[1].split("/");
        let urlLength = urlNewArray.length;
        if (urlLength > 2) {
          slug = "";
          urlNewArray.map((item, index) => {
            let newindex = index + 1;

            if (newindex < urlLength) {
              slug = urlNewArray[urlLength - newindex] + "/" + slug;
            }
          });
        } else {
          slug = urlNewArray[urlLength - 1];
        }
      }

      return (window.location.origin + "/" + slug).toString();
    }

    return ("/" + newurl).toString();
  }
   return [redirectHandle];
  }
  export default useRedirectHandler;